import { RootState } from "src/store/types";
import { getNotificationsSlice } from "../selectors";

export const getSystemAdminNotifications = (state: RootState) =>
  getNotificationsSlice(state).systemAdmin.messages;
